<template>
  <div id="searchLocationContainer" class="">
    <ValidationObserver ref="formValidator">
      <div class="row">
        <div class="col-12 m-md-3 m-sm-0">
          <Title class="col-6 mb-2" :page="page" />
          <BreadCrumb :page="page" />
          <referral-filter
            id="referral-filter"
            ref="filterRef"
            @onSearch="SearchThrpyReferrals"
          />

          <div class="custom-separator-title mt-5 mb-1 pt-2">
            <CustomSeparator
              :text="page.separatorTitle"
              name="resultSeparator"
            />
          </div>
          <custom-result-not-found v-if="referrals.length == 0" />

          <div
            v-for="(item, index) in referrals"
            :key="`referral-item-${index}`"
            class="mb-5 mt-3"
          >
            <custom-callout
              :border-color="getBorderColor(item.statusId)"
              :controlled="true"
              :opened="item.isDetailsOpened"
              @click:open="onCollapseDetails(item)"
            >
              <div class="row">
                <div class="col-12">
                  <div class="row pt-3">
                    <div class="col-sm-12 col-md-2 border-right col-balloon">
                      <div class="row">
                        <div v-if="!showInWaitList" class="col-sm mt-3 mb-4">
                          <custom-balloon
                            v-if="!showInOthers"
                            class="mt-2 font-15"
                            :text="item.status"
                            :background-color="
                              getStatusColor(item.statusId, '')
                            "
                            dot
                          />
                        </div>
                        <div
                          v-if="showInWaitList"
                          class="col-12 pt-3 text-center"
                        >
                          <span class="d-block turn-label">Turno:</span>
                          <span
                            :class="
                              'badge badges ' +
                                getStatusColor(item.statusId, 'badge')
                            "
                          >
                            <strong class="pre-wrap turn-number">
                              {{ item.turnNumber }}
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div class="row" v-if="!showInWaitList">
                        <div class="col ml-sm-none ml-3">
                          <strong>{{ item.referralNumber | empty }}</strong>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col font-weight-normal ml-sm-none ml-3"
                          :class="{ 'wait-list-discipline': showInWaitList }"
                        >
                          <p>{{ item.disciplineName }}</p>
                        </div>
                      </div>
                      <div v-if="item.requestNumberContract" class="row">
                        <div class="col dicipline-name pt-3">
                          <em
                            class="red-icon fas fa-file-signature float-left"
                          />

                          <div class="rp-alert pl-2">
                            <span class="red-icon">
                              Estudiante tiene Contrato de Remedio Provisional
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-if="studentHasRPRequest(item)" class="row">
                        <div class="col dicipline-name pt-3">
                          <em class="orange-icon fas fa-file-invoice" />

                          <div class="rp-alert pl-2">
                            <span class="orange-icon">
                              Estudiante tiene Solicitud de Remedio Provisional
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-if="item.daysCount" class="row">
                        <div class="col dicipline-name pt-3">
                          <p>
                            Días de Vencimiento:
                            <span class="badge-expiration ml-2">
                              {{ item.daysCount }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm">
                      <div class="row mt-3">
                        <div class="col-sm-12 col-md-4">
                          <span class="data-label">Estudiante:</span>
                          <p class="data">
                            {{
                              `${(item.fullName || '').replace(
                                /[0-9]/g,
                                ''
                              )} - ${item.studentSieId}`
                            }}
                          </p>
                        </div>
                        <div class="col-sm-12 col-md-2">
                          <span class="data-label">Edad:</span>
                          <p class="data">{{ item.studentAge }} años</p>
                        </div>
                        <div
                          class="col-sm"
                          v-if="
                            hasRoleForChangeBillingCenter &&
                              canStatusChangeCenter(item.statusId)
                          "
                        >
                          <custom-drop-down
                            v-if="item.admissionId"
                            :options="serviceCenters"
                            fieldkey="id"
                            fieldname="name"
                            label="CSEE:"
                            placeholder="Seleccione"
                            v-model="item.currentCenter"
                            :clearable="false"
                            @input="onChangeCenterHandler(item)"
                          />
                        </div>
                        <div v-else class="col-sm">
                          <span class="data-label">CSEE:</span>
                          <p class="data">
                            {{ item.billingCenterName }}
                          </p>
                        </div>
                        <!-- tipo de servicio -->
                        <div class="col-sm">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-drop-down
                              :options="getDisciplines"
                              fieldkey="id"
                              fieldname="name"
                              label="Tipo de Servicio:"
                              placeholder="Seleccione"
                              v-model="item.currentDisciplineType"
                              :clearable="false"
                              :disabled="!!item.admissionId"
                              @input="onChangeDisciplineHandler(item)"
                              :error="errors[0]"
                              custom-error-msg="Campo requerido."
                            />
                          </validation-provider>
                        </div>
                        <!-- tipo de servicio -->
                      </div>
                      <div class="row mt-4">
                        <div class="col-sm-12 col-md-4">
                          <span class="data-label">Modalidad:</span>
                          <p class="data">
                            {{ item.modalityTypeName }}
                          </p>
                        </div>
                        <div class="col-sm-12 col-md-2">
                          <span class="data-label">Frecuencia:</span>
                          <p class="data">
                            {{ item.frequecy }}
                          </p>
                        </div>
                        <div class="col-sm">
                          <span class="data-label">Duración:</span>
                          <p class="data">
                            {{ item.duration }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          <span class="data-label">Servicio Coordinado:</span>
                          <p class="data">
                            {{ item.coordinatedService ? 'Sí' : 'No' }}
                          </p>
                        </div>
                        <div class="col-sm-3">
                          <span class="data-label">Transportación:</span>
                          <p class="data">
                            {{ item.transportation?.name | empty }}
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="
                          item.statusId ==
                            admissionStatusCodes.ReferidoRechazado
                        "
                        class="row-mt-4"
                      >
                        <div class="mb-3">
                          <label>Comentario Rechazo:</label>
                          <br />
                          <b>{{ item.referralDenyComment }}</b>
                        </div>
                      </div>
                      <div
                        v-if="
                          item.statusId == admissionStatusCodes.NoVinculado &&
                            item.referralUnlinkComment
                        "
                        class="row-mt-4"
                      >
                        <div class="mb-3">
                          <label>Comentario Desvinculación:</label>
                          <br />
                          <b>{{ item.referralUnlinkComment }}</b>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="showInOthers && getOtherMenuItems().length > 0"
                      class="col-md-2 col-lg-2 col-sm-12 d-flex align-items-start pb-3"
                      :class="{ 'justify-content-end': !isMobile }"
                    >
                      <div class="dropdown pr-5">
                        <DropDown
                          :key="item.referralId + item.statusId"
                          :items="getOtherMenuItems()"
                          fix-width
                          @makeReferralOfficial="makeReferralOfficial(item)"
                          @displayViewServices="displayViewServices(item)"
                        />
                      </div>
                    </div>
                    <div
                      v-if="!showInOthers"
                      class="col-md-2 col-lg-2 col-sm-12 d-flex align-items-start pb-3"
                      :class="{ 'justify-content-end': !isMobile }"
                    >
                      <div class="dropdown pr-5">
                        <DropDown
                          :key="item.referralId + item.statusId"
                          :items="getMenuItems(item)"
                          fix-width
                          @goToProvisionalRemedyRequest="
                            goToProvisionalRemedyRequest(item)
                          "
                          @downloadProvissionalRemedyRequestReport="
                            downloadProvissionalRemedyRequestReport(item)
                          "
                          @downloadnotfundsavailable="
                            downloadnotfundsavailable(item)
                          "
                          @goToDocuments="goToDocuments(item)"
                          @goToRecord="goToRecord(item)"
                          @goToLinkRequest="goToLinkRequest(item)"
                          @goToRejectionHistory="goToLinkRequest(item, true)"
                          @setDenegate="
                            setDenegate(item, referralActionTypesCodes.denegate)
                          "
                          @setActionPlan="setActionPlan(item)"
                          @setBreachReason="setBreachReason(item)"
                          @addDiagnosis="addDiagnosis(item)"
                          @setLinkedToNoLinked="
                            setDenegate(
                              item,
                              referralActionTypesCodes.denegateLinked
                            )
                          "
                          @setInactive="setInactive(item)"
                          @downloadSheetRefferal="downloadSheetRefferal(item)"
                          @onDownloadPei="onDownloadPei(item)"
                          @openVisitDetails="openVisitDetails(item)"
                          @toggleContactModal="toggleContactModal(item, index)"
                          @returnStatusToPrevious="returnStatusToPrevious(item)"
                          @goRefferalHistory="goRefferalHistory(item)"
                          @goBreachReasonHistory="
                            goReferralCommentHistory(
                              item,
                              commentTypes.RazonIncumplimiento
                            )
                          "
                          @goPlanActionHistory="
                            goReferralCommentHistory(
                              item,
                              commentTypes.PlanAccion
                            )
                          "
                          @approvalLetterDownload="approvalLetterDownload(item)"
                          @displayBitacora="displayBitacora(item)"
                          @displayAddComment="displayAddComment(item)"
                          @redirectToCommentHistory="
                            handleRedirectToCommentHistory(item)
                          "
                          @displayBitacoraHistory="displayBitacoraHistory(item)"
                          @displayModifyAdmission="
                            displayModifyAdmission(item.admissionId)
                          "
                          @displayAssign="displayAssign(item.admissionId)"
                          @goToAddPlan="goToAddPlan(item)"
                          @goToViewPlan="goToViewPlan(item)"
                          @viewServiceOffering="onViewServiceOffering(item)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <custom-contact-info-modal
                  :studentSieParam="item.studentSieId"
                  ref="contactInfoModalRef"
                  @save="saveModal"
                  @cancel="currentAdmissionId = null"
                />
              </div>
              <template #edition>
                <template
                  v-if="
                    [
                      CALLOUT_MODES.STUDENT_INFORMATION,
                      CALLOUT_MODES.BITACORA,
                      CALLOUT_MODES.HISTORIAL_BITACORA,
                      CALLOUT_MODES.DIAGNOSIS,
                    ].includes(calloutMode)
                  "
                >
                  <b-card
                    class="bg-transparent border-0 p-2"
                    no-body
                    style="padding-bottom: 0;"
                  >
                    <b-card
                      class="bg-white border-0 p-3"
                      no-body
                      style="padding-bottom: 0;"
                    >
                      <b-tabs
                        class="mipe-green-tabs"
                        content-class="pt-4"
                        no-nav-style
                        v-model="tabsModel"
                        @input="(tabValue) => onChangeTab(tabValue, item)"
                      >
                        <b-tab
                          :active="tabsModel === 0"
                          title="Información General"
                        >
                          <div v-if="!showInWaitList">
                            <referral-additional-info
                              :item="item.details"
                              :student-info="item"
                              :is-details-opened="item.isDetailsOpened"
                            />
                          </div>
                        </b-tab>
                        <b-tab
                          v-if="canAddDiagnosis"
                          :active="tabsModel === 1"
                          lazy
                          title="Diagnóstico"
                          @click="addDiagnosis(item)"
                        >
                          <add-diagnosis
                            :item="item"
                            @cancel="onDiagnosisCancel(item)"
                          />
                        </b-tab>
                        <b-tab lazy title="Intervenciones Adeudadas">
                          <InterventionsDue
                            :academic-year-id="item.academicYearId"
                            :discipline-name="item.disciplineName"
                            :discipline-type-id="item.disciplineTypeId"
                            :referral-number="item.referralNumber"
                            :service-specialist-name="item.serviceSpecialist"
                            :student-name="item.fullName"
                            :student-sie-id="item.studentSieId"
                          />
                        </b-tab>
                        <b-tab
                          lazy
                          :active="tabsModel === (canAddDiagnosis ? 3 : 2)"
                          title="Ofrecimiento de Servicios Año Actual"
                        >
                          <service-offering-current-year
                            :data="item.serviceOfferingData"
                            @print="onPrint(item)"
                          />
                        </b-tab>

                        <BitacoraTabs
                          :visible="
                            item.statusId ===
                              admissionStatuses.AprobadoEnRemedioProvisional
                          "
                          :item="item"
                          :commentTypes="blogCommentTypes"
                          @save="handleSaveBlogItem"
                          @cancel="onCollapseDetails"
                        />
                      </b-tabs>
                    </b-card>
                  </b-card>
                </template>
                <template
                  v-else-if="calloutMode === CALLOUT_MODES.CONFIRM_ADMISSION"
                >
                  <ConfirmAdmission
                    :admission-id="item.admissionId"
                    :value="item"
                    :dispose="
                      () => {
                        calloutMode = CALLOUT_MODES.STUDENT_INFORMATION;
                        setReferralItemCollapse({
                          admissionId: item.admissionId,
                          isDetailsOpened: false,
                        });
                      }
                    "
                    @refreshReferralResult="
                      () => {
                        $refs.filterRef.onSearch();
                      }
                    "
                  />
                </template>
                <template
                  v-else-if="calloutMode === CALLOUT_MODES.SERVICE_ACTION"
                >
                  <service-action
                    :action-type="item.actionType"
                    :admission-id="item.admissionId"
                    :status-id="item.statusId"
                    :discipline-type-id="item.disciplineTypeId"
                    :student-sie-id="item.studentSieId"
                    :dispose="
                      () => {
                        disposeServiceAction(item.admissionId);
                      }
                    "
                    @setLinkedToNoLinked="setLinkedToNoLinked"
                  />
                </template>
                <template
                  v-else-if="calloutMode === CALLOUT_MODES.ASSIGN_SPECIALIST"
                >
                  <AssignSpecialist
                    :admission-id="item.admissionId"
                    :value="item"
                    :dispose="
                      () => {
                        calloutMode = CALLOUT_MODES.STUDENT_INFORMATION;
                        setReferralItemCollapse({
                          admissionId: item.admissionId,
                          isDetailsOpened: false,
                        });
                      }
                    "
                    @refreshReferralResult="
                      () => {
                        $refs.filterRef.onSearch();
                      }
                    "
                  />
                </template>
                <template
                  v-else-if="calloutMode === CALLOUT_MODES.AÑADIR_COMENTARIO"
                >
                  <add-comment-form
                    @cancel="onCancelAddCommentHandler(item)"
                    @submit="onSaveAddCommentHandler($event, item)"
                  />
                </template>
                <template
                  v-else-if="calloutMode === CALLOUT_MODES.VIEW_SERVICES"
                >
                  <services
                    :student-sie-id="item.studentSieId"
                    :discipline-type-id="item.disciplineTypeId"
                  />
                </template>
              </template>
            </custom-callout>
          </div>
          <pagination
            v-if="referrals.length > 0 && showPagination"
            :data="pagination"
            @pagination-go-page="onPageChange"
          />
        </div>
      </div>
    </ValidationObserver>
    <visit-details-history ref="visitDetailsHistoryModal" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BreadCrumb from '@/components/common/page/TitleBreadcrumb';
import ReferralFilter from '@/components/pei/ref/Filter';
import CustomSeparator from '@/components/common/CustomSeparator';
import DropDown from '@/components/common/menu/DropDown';
import CustomCallout from 'custom-callout';
import Pagination from 'pagination';
import ThrpiesAdmissionStatuses from '@/utils/constants/thrpiesAdmissionStatuses';
import requestServiceStatuses from '@/utils/constants/requestServiceStatuses';
import generalService from '@/services/pei/general';
import reportService from '@/services/report';
import alert from '@/mixin/alert.mixin';
import VisitDetailsHistory from '@/components/pei/servicehistory/VisitDetailsHistory';
import {
  ReferralAdditionalInfo,
  ServiceAction,
  ConfirmAdmission,
  AssignSpecialist,
} from './components';
import CustomResultNotFound from 'custom-result-not-found';
import * as referralTypes from '@/modules/referral/store/types.js';
import rejectionReasonType from '@/utils/constants/student/rejectionReasonType';
import SearchMode from '@/utils/constants/pei/referral/searchMode';
import userRole from '@/utils/constants/userRoles';
import referralActionTypes from '@/utils/constants/student/referralActionTypes';
import schoolCenters from '@/utils/constants/student/schoolCenters.js';
import commentTypes from '@/utils/constants/comment/codeAdmissionCommentTypes';
import { modulesName } from '@/modules';
import store from '@/store/index';
import ReferralService from '@/modules/referral/api';
import {
  getBlogCommentTypes,
  addBlogItem,
  getStudentServiceOffering,
} from '@/modules/referral/api';
import {
  approveProvisionalRemedyRequest,
  createAdmissionForOtherService,
  createReferralOtherServices,
  returnAdmissionToPreviousStatus,
} from '@/modules/referral/api.js';
import { getDeterminationLetterReport as _getDeterminationLetterReport } from '@/modules/student-answer-rp/api.js';
const CALLOUT_MODES = {
  STUDENT_INFORMATION: 'STUDENT_INFORMATION',
  ASSIGN_SPECIALIST: 'ASSIGN_SPECIALIST',
  CONFIRM_ADMISSION: 'CONFIRM_ADMISSION',
  SERVICE_ACTION: 'SERVICE_ACTION',
  BITACORA: 'BITACORA',
  HISTORIAL_BITACORA: 'HISTORIAL_BITACORA',
  AÑADIR_COMENTARIO: 'AÑADIR_COMENTARIO',
  VIEW_SERVICES: 'VIEW_SERVICES',
  DIAGNOSIS: 'DIAGNOSIS',
};
import CustomBalloon from 'custom-balloon';
import { CustomDropDown } from '@/components/common';
import reportServices from '@/services/report.js';
import generalApi from '@/services/pei/general.js';
import academicYearService from '@/services/academicyear';

const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers(
  modulesName.referralModuleName
);
import pilotPlanRoles from '@/utils/constants/pilotPlanRoles.js';
import InterventionsDue from './components/InterventionsDue';
import AddBlogItem from './components/AddBlogItem';
import RequestDetail from './components/RequestDetail';
import BitacoraHistoryTab from './components/BitacoraHistoryTab';
import AdmissionStatus from '@/utils/constants/pei/referral/admissionStatus';
import ServiceOfferingCurrentYear from './components/ServiceOfferingCurrentYear';
import BitacoraTabs from '@/components/bitacora-tabs/BitacoraTabs.vue';
import { AddCommentForm } from '@quisit/comments';
import studentService from '@/services/student.js';
import objectToFormData from 'object-to-formdata';
import commentCategories from '@/utils/constants/comment/commentTypes';
import StudentStatuses from '@/utils/constants/student/studentStatuses';

import CustomContactInfoModal from '@/components/common/CustomContactInfoModal';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Services from './components/Services';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import AddDiagnosis from './components/AddDiagnosis';

const AVAILABLE_STATUSES_TO_ADD_PLAN = [
  ThrpiesAdmissionStatuses.Admitido,
  ThrpiesAdmissionStatuses.NoVigenteAlta,
  ThrpiesAdmissionStatuses.NoVigenteBajas,
  ThrpiesAdmissionStatuses.ServicioRelacionadoActivo,
  ThrpiesAdmissionStatuses.NoVigenteTraslado,
];

// Department of Education of Puerto Rico company id (CMPNY_Company.CompanyId)
const DEPR_COMPANY_ID = 472;

const AVAILABLE_STATUSES_TO_VIEW_PLAN = [
  ThrpiesAdmissionStatuses.Admitido,
  ThrpiesAdmissionStatuses.ServicioRelacionadoActivo,
  ThrpiesAdmissionStatuses.NoVigenteEgreso,
];

import DocumentsService from '@/services/report';

export default {
  name: 'ReferredManagement',
  mixins: [alert],
  components: {
    CustomCallout,
    Pagination,
    BreadCrumb,
    ReferralFilter,
    CustomSeparator,
    DropDown,
    VisitDetailsHistory,
    ReferralAdditionalInfo,
    ServiceAction,
    ConfirmAdmission,
    AssignSpecialist,
    CustomResultNotFound,
    CustomBalloon,
    CustomDropDown,
    InterventionsDue,
    AddBlogItem,
    RequestDetail,
    BitacoraHistoryTab,
    ServiceOfferingCurrentYear,
    BitacoraTabs,
    AddCommentForm,
    CustomContactInfoModal,
    ValidationProvider,
    ValidationObserver,
    Services,
    AddDiagnosis,
  },
  data() {
    return {
      currentAdmissionId: null,
      calloutOpened: false,
      calloutMode: CALLOUT_MODES.INFORMATION,
      CALLOUT_MODES,
      currentAcademicYearId: null,
      commentTypes,
      savedRequestId: null,
      savedStudentReferralId: null,
      blogItems: [],
      page: {
        icon: 'fas fa-user-circle',
        title: 'Manejo de Referidos',
        routes: ['Inicio', 'PEI', 'Manejo de Referidos', 'Seguimiento'],
        separatorTitle: 'Resultado de Referidos',
      },
      resources: [],
      searchMode: SearchMode,
      canLinkonUnlinked: store.getters.HasPermission(
        'referredmanagement.linkonunlinkstatus'
      ),
      canLinkDenied: store.getters.HasPermission(
        'referredmanagement.linkondeniedstatus'
      ),
      canLinkReferred: store.getters.HasPermission(
        'referredmanagement.linkonreferredstatus'
      ),
      canLinkApprovedProvisionalRemedy: store.getters.HasPermission(
        'referredmanagement.canlinkapprovedprovisionalremedy'
      ),
      showModifyAdmission: false,
      blogCommentTypes: [],
      tabsModel: 0,
      allowedGoToStudentServiceRecord: false,
      canAddDiagnosis: false,
    };
  },
  computed: {
    ...mapGetters({
      referrals: 'getReferralResults',
      pagination: 'getReferralPaging',
      selectedFilterType: 'getSelectedFilterType',
      serviceCenters: 'getServiceCenter',
      getDisciplines: 'getDisciplines',
    }),
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    currentFilters: {
      get() {
        return this.$store.state[modulesName.referralModuleName].referral
          .currentFilters;
      },
      set(value) {
        this.setReferralCurrentFilters(value);
      },
    },
    canAddPlan() {
      return (
        this.hasPermissions('referredmanagement.linkonaddplan') &&
        this.hasPermissions('pei.addInterventionPlan')
      );
    },
    showInWaitList: {
      get() {
        return this.currentFilters.searchMode == this.searchMode.WaitList;
      },
    },
    showInOthers: {
      get() {
        return this.currentFilters.searchMode == this.searchMode.Others;
      },
    },
    hasRoleForChangeBillingCenter() {
      const acceptedRoles = [
        userRole.adminProvider,
        userRole.admin,
        userRole.adminSaee,
        userRole.adminIl,
      ];
      const hasAcceptedRole = acceptedRoles.some(
        (role) => role === this.userRole
      );
      return hasAcceptedRole;
    },
    isSpecialist() {
      return this.userRole === userRole.especialista;
    },
    isDeptEducationSpecialist() {
      const companyIds = (this.userProfile?.companyid || '')
        .split(',')
        .map(Number);
      return this.isSpecialist && companyIds.includes(DEPR_COMPANY_ID);
    },
    referralActionTypesCodes() {
      return referralActionTypes;
    },
    admissionStatuses() {
      return ThrpiesAdmissionStatuses;
    },
    canStatusChangeCenter() {
      return (status) =>
        status != ThrpiesAdmissionStatuses.NoVinculado &&
        status != ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro;
    },
    canModifyAdmission() {
      return this.$store.getters.HasPermission(
        'pei.referralmanagement.canmodifyadmission'
      );
    },
    getBorderColor() {
      return (statusId) => {
        switch (statusId) {
          case ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
          case ThrpiesAdmissionStatuses.ReferidoRechazado:
            return 'brown';
          case ThrpiesAdmissionStatuses.ServicioRelacionadoActivo:
            return 'green';
          case ThrpiesAdmissionStatuses.Asignado:
          case ThrpiesAdmissionStatuses.Admitido:
          case ThrpiesAdmissionStatuses.Vinculado:
            return 'yellow';
          case ThrpiesAdmissionStatuses.NoVinculado:
          case ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro:
          case ThrpiesAdmissionStatuses.Alertas:
            return 'pink';
          case ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional:
            return 'violet';
          default:
            return 'orange';
        }
      };
    },
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.perPage;
    },
    admissionStatusCodes() {
      return ThrpiesAdmissionStatuses;
    },
    userPilotPlan() {
      return store.getters['$_user/pilotPlan'];
    },
    canModifyPlan() {
      return this.$store.getters.HasPermission('pei.modifyAdmissionPlan');
    },
  },
  methods: {
    async getSysParams() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['CanAddDiagnosis', 'AllowedGoToStudentServiceRecord'],
      });

      this.canAddDiagnosis =
        data
          ?.find((x) => x.name == 'CanAddDiagnosis')
          ?.staticValue?.toLowerCase() == 'true' ?? false;

      this.allowedGoToStudentServiceRecord =
        data
          ?.find((x) => x.name == 'AllowedGoToStudentServiceRecord')
          ?.staticValue?.toLowerCase() == 'true' ?? false;
    },
    async toggleContactModal(item, index) {
      await this.$refs.contactInfoModalRef[index].open();
      this.currentAdmissionId = item.admissionId;
    },
    async saveModal(params) {
      let contactInfo = {
        contactName: params.contactname,
        contacteMail: params.contactemail,
        emailSuppliedFlag: params.emailsuppliedflag,
        contactTelephone: params.contacttelephone,
        contactTelephoneProviderCode: params.contacttelephoneprovidercode,
        regStudentId: params.regstudentid,
        contactRelation: params.contactrelation,
        receiveMessageTextFlag: params.receiveMessageTextFlag,
      };
      await studentService.updateStudentContactInformation(contactInfo);
      await this.getReferralsDetails(this.currentAdmissionId);
      this.currentAdmissionId = null;
    },
    ...mapMutations([
      referralTypes.SET_REFERRAL_RESULTS,
      referralTypes.SET_REFERRAL_DETAILS_COLLAPSE,
      referralTypes.SET_REFERRAL_DETAILS_SERVICE_COLLAPSE,
      referralTypes.SET_REFERRAL_CURRENT_FILTERS,
      referralTypes.SET_REFERRAL_SERVICE_CENTER,
      referralTypes.SET_REFERRAL_RESET_SELECTION,
      referralTypes.SET_REFERRAL_ACTION_TYPE,
      referralTypes.SET_REFERRAL_TABLE_CONFIG,
    ]),
    ...mapActions([
      referralTypes.ACTION_TYPES.GET_FILTERS,
      referralTypes.ACTION_TYPES.GET_REFERRALS,
      referralTypes.ACTION_TYPES.GET_REFERRAL_DETAILS,
      referralTypes.ACTION_TYPES.UPDATE_BILLING_CENTER,
      referralTypes.ACTION_TYPES.GET_REFERRAL_REJECTION_REASON,
    ]),
    hasBitacora(item) {
      return !!item.requestServiceId;
    },
    getHexaColor(statusId) {
      switch (statusId) {
        case ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
        case ThrpiesAdmissionStatuses.ReferidoRechazado:
          return '#d5b89a';
        case ThrpiesAdmissionStatuses.ServicioRelacionadoActivo:
          return '#A3E5B3';
        case ThrpiesAdmissionStatuses.Asignado:
        case ThrpiesAdmissionStatuses.Admitido:
        case ThrpiesAdmissionStatuses.Vinculado:
          return '#f8ea8';
        case ThrpiesAdmissionStatuses.NoVinculado:
        case ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro:
        case ThrpiesAdmissionStatuses.Alertas:
          return '#fcc9c8';
        case ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional:
          return '#ddb3d7';
        default:
          return '#f8ca80';
      }
    },
    async fetchBlogCommentTypes() {
      const { data } = await getBlogCommentTypes();
      this.blogCommentTypes = data;
    },
    async handleSaveBlogItem(data) {
      try {
        const formData = new FormData();
        formData.append('comment', data.comment);
        formData.append('commentTypeId', data.commentTypeId);
        formData.append('fileAlias', data.fileAlias);
        formData.append('file', data.file);

        await addBlogItem(data.requestServiceId, formData);
        this.ShowToast(
          '',
          'Elemento agregado a la bitácora correctamente.',
          'success'
        );
      } catch (err) {
        this.ShowToast(
          'Alerta',
          'Ocurrió un error al agregar un nuevo elemento a la bitácora',
          'error'
        );
      }
    },
    async getCurrentAcademicYear() {
      const {
        data: current,
      } = await academicYearService.getCurrentAcademicYear();
      this.currentAcademicYearId = current.id;
    },
    showError(error) {
      const errorMsg =
        error.data && error.data.message
          ? error.data.message
          : error.response.data.message;
      this.ShowToast('Error', errorMsg, 'error');
    },
    async SearchThrpyReferrals(model, isNewSearch) {
      this.currentFilters = model;
      this.$refs.formValidator.reset();
      let startRowIndex = 1;
      if (!isNewSearch) {
        if (this.pagination.currentPage > 1) {
          startRowIndex = this.pagination.currentPage;
        }
      }

      let filters = {
        searchMode: model.searchMode,
        fiscalYear: model.academicYear,
        month: model.month,
        statusId: model.admissionStatus,
        referralTypeId: model.admissionReferralType,
        modalityTypeId: model.modalityTypeId,
        reasonId: model.admissionStatusReason,
        centerId: model.center,
        municipalityId: model.municipality,
        schoolId: model.school,
        serviceId: model.discipline,
        providerId: model.providerId,
        specialistId: model.specialistId,
        locationTypeCd: model.locationTypeId,
        locationFiscalYearId: model.locationServiceId,
        pageIndex: startRowIndex,
        pageSize: this.pagination.perPage,
        searchText: model.searchText,
        thrpyReferralAlertTypes: model.thrpyReferralAlertTypes,
        coordinatedService: model.coordinatedService,
        transportTypeId: model.transportTypeId,
      };
      this.getReferrals({ filters: filters, currentFilters: model });
    },
    getStatusColor(statusId, classPrefix) {
      switch (statusId) {
        case ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
        case ThrpiesAdmissionStatuses.ReferidoRechazado: {
          return !classPrefix ? 'brown' : `${classPrefix}-active-service-brown`;
        }
        case ThrpiesAdmissionStatuses.ServicioRelacionadoActivo: {
          return !classPrefix
            ? 'green-light'
            : `${classPrefix}-active-service-green`;
        }
        case ThrpiesAdmissionStatuses.Asignado:
        case ThrpiesAdmissionStatuses.Admitido:
        case ThrpiesAdmissionStatuses.Vinculado: {
          return !classPrefix
            ? 'yellow'
            : `${classPrefix}-active-service-yellow`;
        }
        case ThrpiesAdmissionStatuses.NoVinculado:
        case ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro:
        case ThrpiesAdmissionStatuses.Alertas: {
          return !classPrefix ? 'pink' : `${classPrefix}-active-service-pink`;
        }
        case ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional: {
          return !classPrefix
            ? 'violet'
            : `${classPrefix}-active-service-violet`;
        }
        default: {
          return !classPrefix
            ? 'primary-2'
            : `${classPrefix}-active-service-orange`;
        }
      }
    },
    canLink(statusId) {
      let result = false;

      switch (statusId) {
        case ThrpiesAdmissionStatuses.NoVinculado:
        case ThrpiesAdmissionStatuses.NoVinculadoTrasnferidoSAE:
        case ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro:
          result =
            this.canLinkonUnlinked &&
            ((pilotPlanRoles.includes(this.userRole) && this.userPilotPlan) ||
              !pilotPlanRoles.includes(this.userRole));
          break;
        case ThrpiesAdmissionStatuses.ReferidoRechazado:
          result = this.canLinkDenied;
          break;
        case ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
          result = this.canLinkReferred;
          break;
        case ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional:
          result =
            this.canLinkApprovedProvisionalRemedy &&
            this.hasPermissions('referredmanagement.linkonaprovedstatus');
          break;
      }

      return result;
    },
    //Table Methods
    updateParams(newProps) {
      this[referralTypes.SET_REFERRAL_TABLE_CONFIG]({
        ...newProps,
      });
    },
    async onPageChange(page) {
      this.updateParams({ currentPage: page });
      this.SearchThrpyReferrals(this.currentFilters, false);
    },
    displayModifyAdmission(admissionId) {
      this.calloutMode = this.CALLOUT_MODES.CONFIRM_ADMISSION;
      this.setReferralItemCollapse({
        admissionId: admissionId,
        isDetailsOpened: true,
      });
    },
    displayAssign(admissionId) {
      this.calloutMode = this.CALLOUT_MODES.ASSIGN_SPECIALIST;
      this.setReferralItemCollapse({
        admissionId: admissionId,
        isDetailsOpened: true,
      });
    },
    displayBitacora(item) {
      this.calloutMode = this.CALLOUT_MODES.BITACORA;
      this.setReferralItemCollapse({
        admissionId: item.admissionId,
        isDetailsOpened: true,
      });
      this.tabsModel = this.canAddDiagnosis ? 4 : 3;
    },
    displayBitacoraHistory(item) {
      this.calloutMode = this.CALLOUT_MODES.HISTORIAL_BITACORA;
      this.setReferralItemCollapse({
        admissionId: item.admissionId,
        isDetailsOpened: true,
      });
      this.tabsModel = this.canAddDiagnosis ? 5 : 4;
    },
    displayAddComment(item) {
      this.calloutMode = this.CALLOUT_MODES.AÑADIR_COMENTARIO;
      item.isDetailsOpened = true;
    },
    async displayViewServices(row) {
      const isValid = await this.$refs.formValidator.validate();

      if (!row.currentDisciplineType && !isValid) {
        this.ShowToast(
          'Alerta',
          'Debe contar con una clasificación para el referido',
          'error'
        );

        return;
      }

      this.calloutMode = this.CALLOUT_MODES.VIEW_SERVICES;
      this.setReferralServiceItemCollapse({
        isDetailsOpened: true,
        studentServiceId: row.studentServiceId,
      });
    },
    handleRedirectToCommentHistory(item) {
      this.$router.push({
        path: `/student/comments/commentshistory/${item.studentSieId}/${commentCategories.ManejoReferidos}`,
      });
    },
    onCancelAddCommentHandler(item) {
      item.isDetailsOpened = false;
    },
    async onSaveAddCommentHandler(payload, item) {
      try {
        let formData = objectToFormData(
          {
            studentSieId: item.studentSieId,
            categoryTypeId: commentCategories.ManejoReferidos,
            description: payload.comment,
          },
          { indices: true }
        );

        if (payload.file) {
          formData.append('attachment', payload.file);
        }

        await studentService.saveComment(formData);

        this.ShowToast(
          'Completado',
          'Su información ha sido procesada exitosamente.',
          'success'
        );
        item.isDetailsOpened = false;
      } catch (e) {
        this.ShowToast('', e.message || 'error', 'error');
      }
    },
    disposeServiceAction(admissionId) {
      this.calloutMode = CALLOUT_MODES.STUDENT_INFORMATION;
      this.setReferralItemCollapse({
        admissionId: admissionId,
        isDetailsOpened: false,
      });

      this[referralTypes.SET_REFERRAL_ACTION_TYPE]({
        id: this.studentServiceId,
        actionType: null,
      });
    },
    showIfContainStatus(statuses, statusId) {
      return statuses.some((id) => id === statusId);
    },
    getMenuItems(props) {
      let items = [];

      const isReferralFromCurrentYear =
        props.academicYearId === this.currentAcademicYearId;

      const canDenyWhenStatusDeny =
        isReferralFromCurrentYear &&
        (props.statusId === ThrpiesAdmissionStatuses.NoVinculado ||
          props.statusId ===
            ThrpiesAdmissionStatuses.NoVinculadoTrasnferidoSAE ||
          props.statusId ===
            ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro) &&
        this.hasPermissions('referredmanagement.denyreferredonunlinkstatus');

      const canDenyWhenStatusApprovedInRemPro =
        isReferralFromCurrentYear &&
        props.statusId ===
          ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional &&
        this.hasPermissions('referredmanagement.denyreferredonaprovedstatus');

      const canDenyWhenStatusReferedToDirectorCSEE =
        isReferralFromCurrentYear &&
        props.statusId === ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE &&
        this.hasPermissions('referredmanagement.denyonreferredstatus');

      const canDenyForPreviousYear =
        props.academicYearId < this.currentAcademicYearId &&
        (props.statusId === ThrpiesAdmissionStatuses.NoVinculado ||
          props.statusId ===
            ThrpiesAdmissionStatuses.NoVinculadoTrasnferidoSAE) &&
        this.hasPermissions('pei.referralmanagement.denypreviousyear');

      const canLinkForPreviousYear =
        props.academicYearId < this.currentAcademicYearId &&
        props.statusId === ThrpiesAdmissionStatuses.NoVinculado &&
        this.hasPermissions('referredmanagement.linkreferredonotlinked');

      const canAssignForPreviousYear =
        props.academicYearId < this.currentAcademicYearId &&
        props.statusId === ThrpiesAdmissionStatuses.Vinculado &&
        this.hasPermissions('pei.referralmanagement.assignpreviousyear');

      items = [
        {
          Title: ' Crear Solicitud de Remedio Provisional',
          Icon: 'fas fa-plus-circle',
          IconColor: 'text-green',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'goToProvisionalRemedyRequest',
          Visible:
            props.statusId ===
              ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE &&
            this.hasPermissions('referredmanagement.remedy'),
          Children: [],
        },
        {
          Title: ' Vincular ',
          Icon: 'fas fa-plus-square',
          IconColor: 'text-green',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'goToLinkRequest',
          Visible:
            canLinkForPreviousYear ||
            (isReferralFromCurrentYear && this.canLink(props.statusId)),
          Children: [],
        },
        {
          Title: ' Denegar ',
          Icon: 'fas fa-times-square',
          IconColor: 'text-red',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'setDenegate',
          Visible:
            canDenyForPreviousYear ||
            canDenyWhenStatusDeny ||
            canDenyWhenStatusApprovedInRemPro ||
            canDenyWhenStatusReferedToDirectorCSEE,
          Children: [],
          HasLine: true,
        },
        {
          Title: ' Denegar ',
          Icon: 'fas fa-times-square',
          IconColor: 'text-red',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'setLinkedToNoLinked',
          Visible:
            (props.statusId === ThrpiesAdmissionStatuses.Vinculado &&
              this.hasPermissions(
                'referredmanagement.denyreferredonunlinkstatus'
              )) ||
            (props.statusId === ThrpiesAdmissionStatuses.Vinculado &&
              props.selfAssign &&
              this.isSpecialist),
          Children: [],
          HasLine: true,
        },
        {
          Title: ' Descargar Solicitud',
          Icon: 'fas fa-download',
          IconColor: 'text-green',
          Item: props.studentReferralId,
          Type: 'Menu',
          EmitGo: 'downloadProvissionalRemedyRequestReport',
          Visible:
            props.statusId ===
            ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional,
          Children: [],
        },
        {
          Title: 'Descargar Carta de Aprobación',
          Icon: 'fas fa-download',
          IconColor: 'text-green',
          Item: props.studentReferralId,
          Type: 'Menu',
          EmitGo: 'approvalLetterDownload',
          Visible:
            props.statusId ===
            ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional,
          Children: [],
          HasLine: true,
        },
        {
          Title: 'Ver Provisión de Servicios',
          Icon: 'fas fa-download',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'downloadnotfundsavailable',
          Visible: this.showInWaitList,
          Children: [],
          HasLine: true,
        },
      ];

      if (AVAILABLE_STATUSES_TO_ADD_PLAN.includes(props.statusId)) {
        items = [
          {
            Title: ' Añadir Plan ',
            Icon: 'fas fa-files-medical',
            IconColor: 'text-green',
            Item: props.studentSieId,
            Type: 'Menu',
            EmitGo: 'goToAddPlan',
            Visible: this.canAddPlan,
            Children: [],
          },
        ];
      }

      if (AVAILABLE_STATUSES_TO_VIEW_PLAN.includes(props.statusId)) {
        items = [
          {
            Title: ' Ver Plan ',
            Icon: 'fas fa-files-medical',
            IconColor: 'text-green',
            Item: props.hasInterventionPlan,
            Type: 'Menu',
            EmitGo: 'goToViewPlan',
            Visible: !!props.hasInterventionPlan,
            Children: [],
          },
        ];
      }
      //Report Options in First Option in Menu
      items.unshift(...this.getReportsItems(props));
      items.push(...this.getHistoryItems(props));
      // adds Modificar Admission
      items.push(
        ...[
          {
            Title: 'Modificar Admisión',
            Icon: 'fas fa-clipboard-user',
            IconColor: 'text-green',
            Item: props,
            Type: 'Menu',
            EmitGo: 'displayModifyAdmission',
            Visible:
              this.canModifyAdmission &&
              this.canModifyPlan &&
              this.showIfContainStatus(
                [
                  ThrpiesAdmissionStatuses.Admitido,
                  ThrpiesAdmissionStatuses.ServicioRelacionadoActivo,
                  ThrpiesAdmissionStatuses.NoVigenteBajas,
                  ThrpiesAdmissionStatuses.NoVigenteAlta,
                  ThrpiesAdmissionStatuses.NoVigenteTraslado,
                ],
                props.statusId
              ),
            Children: [],
          },
          {
            Title: 'Asignar',
            Icon: 'fas fa-plus-square',
            IconColor: 'text-green',
            Item: props,
            Type: 'Menu',
            EmitGo: 'displayAssign',
            Visible:
              canAssignForPreviousYear ||
              (isReferralFromCurrentYear &&
                props.statusId === ThrpiesAdmissionStatuses.Vinculado &&
                this.isDeptEducationSpecialist) ||
              (this.showIfContainStatus(
                [ThrpiesAdmissionStatuses.Vinculado],
                props.statusId
              ) &&
                props.selfAssign),
            Children: [],
          },
          {
            Title: 'Bitácora de Seguimiento RP',
            Icon: 'fas fa-file-signature',
            IconColor: 'text-green',
            Item: props,
            Type: 'Menu',
            EmitGo: 'displayBitacora',
            Visible: this.hasBitacora(props),
            Children: [],
          },
        ]
      );

      return items;
    },
    getOtherMenuItems() {
      return [
        {
          Title: 'Oficializar Referido',
          Icon: 'fas fa-file-edit',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'makeReferralOfficial',
          Visible: this.hasPermissions(
            'academic.pei.referralmanagement.canmakeofficial'
          ),
          Children: [],
        },
        {
          Title: 'Ver Servicios',
          Icon: 'fas fa-info-circle',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'displayViewServices',
          Children: [],
        },
      ];
    },
    getReportsItems(props) {
      return [
        {
          Title: 'Descargar PEI ',
          Icon: 'fas fa-print',
          IconColor: 'text-green',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'onDownloadPei',
          Visible: true,
          Children: [],
        },
        {
          Title: ' Ver Documentos ',
          Icon: 'fas fa-file-alt',
          IconColor: 'text-green',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'goToDocuments',
          Children: [],
          Visible: !this.allowedGoToStudentServiceRecord,
        },
        {
          Title: ' Ver Expediente ',
          Icon: 'fas fa-file-alt',
          IconColor: 'text-green',
          Item: props.studentServiceId,
          Type: 'Menu',
          EmitGo: 'goToRecord',
          Children: [],
          Visible: this.allowedGoToStudentServiceRecord,
        },
        {
          Title: 'Ver Hoja de Referido ',
          Icon: 'fas fa-file-download',
          IconColor: 'text-green',
          Item: props.studentServiceId,
          Type: 'Menu',
          EmitGo: 'downloadSheetRefferal',
          Visible: true,
          Children: [],
          HasLine: true, //Always add to end Collection
        },
        {
          Title: 'Añadir Comentario',
          Icon: 'fas fa-comment',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'displayAddComment',
          Visible: true,
          Children: [],
        },
        {
          Title: 'Comentario',
          Icon: 'fas fa-file-alt text-green',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'redirectToCommentHistory',
          Visible: true,
          Children: [],
        },
        {
          Title: 'Plan de Acción',
          Icon: 'fas fa-file-alt',
          IconColor: 'text-green',
          Item: props.studentServiceId,
          Type: 'Menu',
          EmitGo: 'setActionPlan',
          Visible: true,
          Children: [],
        },
        {
          Title: 'Ofrecimiento de Servicios Año Actual',
          Icon: 'fas fa-calendar-circle-user',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'viewServiceOffering',
          Visible: true,
          Children: [],
          HasLine: !this.canAddDiagnosis, //Always add to end Collection
        },
        {
          Title: props.hasDiagnostics
            ? 'Ver/Editar Diagnóstico'
            : 'Añadir Diagnóstico',
          Icon: 'fas fa-file-alt color-primary-1',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'addDiagnosis',
          Visible: this.canAddDiagnosis,
          Children: [],
          HasLine: true, //Always add to end Collection
        },
        {
          Title: 'Razón Incumplimiento',
          Icon: 'fas fa-file-alt',
          IconColor: 'text-green',
          Item: props.studentServiceId,
          Type: 'Menu',
          EmitGo: 'setBreachReason',
          Visible: true,
          Children: [],
          HasLine: false, //Always add to end Collection
        },
      ];
    },
    getHistoryItems(props) {
      return [
        {
          Title: ' Historial de Rechazos ',
          Icon: 'fas fa-history',
          IconColor: 'text-green',
          Item: props.studentSieId,
          Type: 'Menu',
          EmitGo: 'goToRejectionHistory',
          Children: [],
          Visible: !this.showInWaitList,
        },
        {
          Title: 'Historial del Referido',
          Icon: 'fas fa-history',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'goRefferalHistory',
          Children: [],
          Visible: !this.showInWaitList,
        },
        {
          Title: 'Historial de Bitácora',
          Icon: 'fas fa-history',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'displayBitacoraHistory',
          Children: [],
          Visible: this.hasBitacora(props),
        },
        {
          Title: 'Historial de Razón de Incumplimiento',
          Icon: 'fas fa-history',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'goBreachReasonHistory',
          Children: [],
          Visible: props.comments.some(
            (comment) =>
              comment.commentTypeCode == commentTypes.RazonIncumplimiento
          ),
        },
        {
          Title: 'Historial de Plan de Acción',
          Icon: 'fas fa-history',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'goPlanActionHistory',
          Children: [],
          Visible: props.comments.some(
            (comment) => comment.commentTypeCode == commentTypes.PlanAccion
          ),
        },
        {
          Title: 'Historial de Visitas',
          Icon: 'fas fa-user-clock',
          IconColor: 'text-green',
          Item: props.admissionId,
          Type: 'Menu',
          EmitGo: 'openVisitDetails',
          Visible: !this.showInWaitList,
          Children: [],
          HasLine: true,
        },
        {
          Title: 'Actualizar Contacto',
          Icon: 'fas fa-user-edit',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'toggleContactModal',
          Visible: this.userHasPermissions('academic.parentcontact.update'),
          Children: [],
          HasLine: false,
        },
        {
          Title: 'Devolver Estatus',
          Icon: 'fas fa-reply',
          IconColor: 'text-green',
          Item: props,
          Type: 'Menu',
          EmitGo: 'returnStatusToPrevious',
          Visible:
            this.userHasPermissions(
              'academic.referral.canreturntopreviousstatus'
            ) &&
            props.statusId == ThrpiesAdmissionStatuses.NoVigenteEgreso &&
            props.studentStatusCode == StudentStatuses.Servido &&
            props.academicYearId == this.currentAcademicYearId,
          Children: [],
          HasLine: false,
        },
      ];
    },
    studentHasRPRequest(item) {
      return (
        item.requestNumberService &&
        item.statusId != ThrpiesAdmissionStatuses.NoVinculadoTrasnferidoSAE &&
        (item.requestServiceStatusId == requestServiceStatuses.New ||
          item.requestServiceStatusId == requestServiceStatuses.Approved)
      );
    },
    hasPermissions(permission) {
      return this.$store.getters.HasPermission(permission);
    },
    async makeReferralOfficial(row) {
      const isValid = await this.$refs.formValidator.validate();

      if (!row.currentDisciplineType && !isValid) {
        this.ShowToast(
          'Alerta',
          'Debe contar con una clasificación para el referido',
          'error'
        );

        return;
      }

      this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea oficializar el referido para el servicio ${row.currentDisciplineType.name}?`,
        'Sí',
        'No'
      ).then(async (response) => {
        if (response) {
          await createAdmissionForOtherService({
            studentServiceId: row.studentServiceId,
            academicYearId: row.academicYearId,
            disciplineTypeId: row.currentDisciplineType.id,
            peiId: row.peiId,
            studentSieId: row.studentSieId,
          })
            .then(() => {
              this.ShowToast(
                'Proceso exitoso',
                'Se ha creado el servicio en Manejo de Referidos',
                'success'
              );
              this.SearchThrpyReferrals(this.currentFilters, false);
            })
            .catch((err) => {
              this.ShowToast('', err.response?.data?.message, 'error');
            });
        }
      });
    },
    async goToProvisionalRemedyRequest(row) {
      let self = this;
      self
        .$ApiGet(
          `/api/studentreferrals/checkprovisionalremedyrequest/${row.studentSieId}/${row.disciplineTypeId}`
        )
        .then((res) => {
          if (res.data != null && res.data != '') {
            self.savedRequestId = res.data.id;
            self.savedStudentReferralId = res.data.StudentReferralId;
            this.ShowCancelModal(
              'Confirmación',
              `Se encontró un servicio activo en Remedio Provisional para la misma disciplina del referido bajo la(s) solicitud(es) ${res.data.requestNumber} ¿Desea identificar este referido como Aprobado en Remedio Provisional utilizando la solicitud encontrada?`,
              'Sí',
              'No'
            ).then(async (response) => {
              if (response) {
                await approveProvisionalRemedyRequest({
                  admissionId: row.admissionId,
                  requestId: self.savedRequestId,
                  disciplineTypeId: row.disciplineTypeId,
                });
                this.SearchThrpyReferrals(this.currentFilters, false);
              }
            });
          } else {
            this.pushPageProvisionalRemedyRequest(row);
          }
        })
        .catch((err) => {
          this.showError(err);
        });
    },
    downloadProvissionalRemedyRequestReport(row) {
      let self = this;
      let requestNumber = row.requestNumberService;
      self
        .$ApiGet(
          `/api/studentevaluation/requestreportdownload?requestNumber=${requestNumber}`
        )
        .then((res) => {
          generalService.documentDownloadReport(
            res.data.content,
            res.data.filename
          );
        })
        .catch((err) => {
          this.showError(err);
        });
    },
    async goToLinkRequest(row, isReadonly = false) {
      const hasProvisionalRemedyActive = await this.$ApiGet(
        `api/studentreferrals/hasactiveprovisionalremedy?studentSieId=${row.studentSieId}
        &disciplineTypeId=${row.disciplineTypeId}&academicYearId=${row.academicYearId}&requestStatusId=${row.statusId}`
      ).catch((err) => {
        this.showError(err);
      });

      if (
        hasProvisionalRemedyActive &&
        hasProvisionalRemedyActive.data === false
      ) {
        if (
          row.locationSchoolId !== schoolCenters.PublicCenter &&
          row.locationSchoolId !== schoolCenters.PrivateCenter &&
          row.locationSchoolId !== -1
        ) {
          this.setDenegate(row, null);
          this.$router.push({
            name: 'peiReferralLink',
            params: {
              studentServiceId: row.studentServiceId,
              admissionId: row.admissionId,
              isReadonly: isReadonly,
              serviceInfo: {
                studentName: row.fullName,
                referralNumber: row.referralNumber,
                studentSieId: row.studentSieId,
                disciplineName: row.disciplineName,
                studentServiceId: row.studentServiceId,
              },
            },
          });
        } else {
          this.ShowToast(
            'Error',
            'El estudiante no puede ser vinculado ya que no contiene una escuela válida en sistema.',
            'error'
          );
        }
      }
    },
    goToAddPlan(row) {
      this.$router.push({
        name: 'peiServiceHistoryDocuments',
        params: {
          studentServiceId: row.studentServiceId,
          allowAddDocument: true,
          mainTitle: 'Añadir Plan',
          routeTitle: 'Seguimiento',
          servicePlan: {
            providerName: row.providerName,
            admissionId: row.admissionId,
          },
        },
      });
    },
    goToViewPlan(row) {
      this.$router.push({
        path: `/pei/ref/intervention-plan/${row.hasInterventionPlan}/${row.admissionId}`,
      });
    },
    goToRecord(row) {
      this.$router.push({
        path: `/pei/ref/${row.studentServiceId}/record`,
      });
    },
    async approvalLetterDownload(row) {
      _getDeterminationLetterReport({
        requestServiceId: row.requestServiceId,
        determinationReasonId: 0,
      })
        .then((res) => generalApi.ConvertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    goToDocuments(row) {
      this.$router.push({
        name: 'peiServiceHistoryDocuments',
        params: {
          studentServiceId: row.studentServiceId,
          allowAddDocument: true,
          routeTitle: 'Manejo de Referidos',
          tab: null,
          isInterventionPlanSubmitted: row.isSubmitted,
          resultSummary: row.hasSummary,
          achievementSummary: row.referralHasAchievementSummary,
          interventionPlanId: row.hasInterventionPlan,
          admissionId: row.admissionId,
        },
      });
    },
    async pushPageProvisionalRemedyRequest(row) {
      let ProvisionalRemedyRequestRef = {
        name: row.fullName,
        sie: row.studentSieId,
        academicYearId: this.$refs.filterRef.selectedAcademicYear.id,
        disciplineName: row.disciplineName,
        modalityTypeName: row.modalityTypeName,
        frequecy: row.frequecy,
        duration: row.duration,
        ThrpyDisciplineTypeId: row.disciplineTypeId,
        ThrpyTherapyDurationId: row.therapyDurationId,
        ThrpyFrequencyTypeId: row.frequencyTypeId,
        ThrpyModalityTypeId: row.modalityTypeId,
        ThrpyReferralDate: row.referralDate,
        ThrpyAdmissionId: row.admissionId,
        IsThrpy: true,
      };

      this.$store.dispatch(
        'setProvisionalRemedyRequestRef',
        ProvisionalRemedyRequestRef
      );

      this.$router.push({
        path: `/pei/ref/ProvisionalRemedyRequest`,
      });
    },
    async showCommentSection(studentServiceId, actionType) {
      await this[referralTypes.ACTION_TYPES.GET_REFERRAL_REJECTION_REASON]({
        type: rejectionReasonType.DenegarVinculadoRP,
      });
      this[referralTypes.SET_REFERRAL_ACTION_TYPE]({
        id: studentServiceId,
        actionType: actionType,
      });
      this.calloutMode = this.CALLOUT_MODES.SERVICE_ACTION;
    },
    async setActionPlan(props) {
      await this.showCommentSection(
        props.studentServiceId,
        referralActionTypes.actionPlan
      );
      this.setReferralItemCollapse({
        admissionId: props.admissionId,
        isDetailsOpened: true,
      });
    },
    async setBreachReason(props) {
      await this.showCommentSection(
        props.studentServiceId,
        referralActionTypes.breachReason
      );
      this.setReferralItemCollapse({
        admissionId: props.admissionId,
        isDetailsOpened: true,
      });
    },
    onDiagnosisCancel(item) {
      this.tabsModel = null;
      this.calloutMode = null;
      this.setReferralItemCollapse({
        admissionId: item.admissionId,
        isDetailsOpened: false,
      });
    },
    async addDiagnosis(item) {
      this.tabsModel = 1;
      this.calloutMode = this.CALLOUT_MODES.DIAGNOSIS;
      this.setReferralItemCollapse({
        admissionId: item.admissionId,
        isDetailsOpened: true,
      });
    },
    async setDenegate(props, value) {
      const hasRpRequest = this.studentHasRPRequest(props);
      if (hasRpRequest && props?.requestNumberService?.length) {
        const alertMessage = `El servicio no podrá ser actualizado ya que se encuentra activo en Remedio Provisional bajo la solicitud ${props?.requestNumberService}`;
        this.ShowToast('Alerta', alertMessage, 'error');
        return;
      }

      await this.showCommentSection(props.studentServiceId, value);
      this.setReferralItemCollapse({
        admissionId: props.admissionId,
        isDetailsOpened: true,
      });
    },
    async setLinkedToNoLinked(props) {
      let response = await alert.methods.ShowConfirm(
        'Atención',
        '¿Está seguro que desea desvincular este referido?'
      );
      if (response) {
        await ReferralService.ReferralUnlink({
          referralId: props.admissionId,
          comment: props.comment,
          rejectionReasonId: props.rejectionReasonId,
        })
          .then(() => {
            this.ShowToast(
              'Proceso exitoso',
              'Cambio realizado satisfactoriamente',
              'success'
            );
            this.SearchThrpyReferrals(this.currentFilters, false);
          })
          .catch();
      }
    },
    setInactive(props) {
      if (this.studentIsActiveInRempro(props)) return false;
    },
    studentIsActiveInRempro(props) {
      if (
        props.statusId == ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional
      ) {
        if (props.requestNumberService != '') {
          this.ShowToast(
            'Alerta',
            this.getMessage('0709').replace(
              '{###}',
              props.requestNumberService
            ),
            'error'
          );
          return true;
        }

        if (props.requestNumberContract != '') {
          this.ShowToast(
            'Alerta',
            this.getMessage('0709').replace(
              '{###}',
              props.requestNumberContract
            ),
            'error'
          );
          return true;
        }

        return false;
      }
    },
    downloadSheetRefferal(props) {
      reportService.downloadReferralReportFromStudentService(
        props.studentServiceId
      );
    },
    async onDownloadPei(row) {
      if (row.studentSieId) {
        await reportServices
          .getLatestSignedPeipReport(row.studentSieId)
          .then((res) => {
            generalApi.documentDownloadReport(
              res.data.content,
              res.data.filename
            );
          });
      }
    },
    openVisitDetails(row) {
      if (row.admissionId != null && this.$refs.visitDetailsHistoryModal) {
        this.$refs.visitDetailsHistoryModal.open(row.admissionId);
      }
    },
    goRefferalHistory(row) {
      const { admissionId, referralNumber } = row;
      this.$router.push({
        name: 'pei-status-history',
        params: {
          admissionId: admissionId,
          referralNumber: referralNumber,
        },
      });
    },
    goReferralCommentHistory(row, commentType) {
      const { admissionId, referralNumber } = row;
      this.$router.push({
        name: 'referral-comment-history',
        params: {
          admissionId: admissionId,
          referralNumber: referralNumber,
          commentType,
        },
      });
    },
    onCollapseDetails(row) {
      this.tabsModel = 0;
      const { admissionId, details } = row;
      if (!details) {
        this.getReferralsDetails(admissionId);
        this.setReferralItemCollapse({ admissionId, isDetailsOpened: false });
      } else {
        this.setReferralItemCollapse({
          admissionId,
          isDetailsOpened: !row.isDetailsOpened,
        });
      }
      this.calloutMode = this.CALLOUT_MODES.STUDENT_INFORMATION;
      this.calloutOpened = !this.calloutOpened;
    },
    async onChangeCenterHandler(item) {
      const center = item.currentCenter;
      if (center.id) {
        const canContinue = await this.ShowCancelModal(
          'Atención',
          this.getMessage('0704'),
          'Sí',
          'No'
        );
        if (canContinue) {
          await this.updateBillingCenter({
            admissionId: item.admissionId,
            newBillingCenterId: center.id,
            newBillingCenterName: center.name,
            disciplineTypeId: item.disciplineTypeId,
            studentSieId: item.studentSieId,
            academicYearId: item.academicYearId,
            companyId: item.companyId,
          });
        } else {
          item.currentCenter = this.serviceCenters.find(
            (x) => x.id === item.providerLinkCenterId
          );
        }
      }
    },
    async onChangeDisciplineHandler(item) {
      if (await this.checkIfReferralExistOnOther(item)) return;
      let isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea completar la clasificación del servicio y crear el mismo en Manejo de Referidos?',
        'Si',
        'No'
      );

      if (!isConfirmed) {
        item.currentDisciplineType =
          this.getDisciplines.find((x) => x.id === item.disciplineTypeId) ||
          null;
        return;
      }

      const { data } = await createReferralOtherServices({
        studentServiceId: item.studentServiceId,
        disciplineTypeId: item.currentDisciplineType.id,
      });

      if (data) {
        await this.SearchThrpyReferrals(this.currentFilters, false);
        this.ShowToast(
          'Proceso exitoso',
          'Se ha creado el servicio en Manejo de Referidos',
          'success'
        );
      }
    },
    async checkIfReferralExistOnOther(item) {
      if (this.showInOthers && item.admissionId && item.referralNumber) {
        const referral = await ReferralService.getthrpyreferraldetails(
          item.admissionId
        );
        if (referral && referral.statusId !== AdmissionStatus.NoVinculado) {
          item.currentDisciplineType =
            this.getDisciplines.find((x) => x.id === item.disciplineTypeId) ||
            null;
          this.ShowToast(
            'Alerta',
            'No es posible realizar la clasificación debido a que existe un referido en un estatus no elegible para clasificación.',
            'error'
          );
          return true;
        }
      }
      return false;
    },
    async downloadnotfundsavailable(row) {
      let self = this;
      await reportService
        .downloadnotfundsavailable({
          peiId: row.peiId,
          disciplineTypeCd: row.disciplineTypeId,
          assignedTurn: row.turnNumber,
        })
        .catch((err) => {
          self.ShowToast('Error', err.message, 'error');
        });
    },
    async onViewServiceOffering(item) {
      const {
        admissionId,
        academicYearId,
        studentSieId,
        disciplineTypeId,
      } = item;
      this.getReferralsDetails(admissionId);
      this.setReferralItemCollapse({
        admissionId,
        isDetailsOpened: true,
      });
      this.calloutMode = this.CALLOUT_MODES.STUDENT_INFORMATION;
      this.calloutOpened = true;
      const { data } = await getStudentServiceOffering({
        academicYearId,
        studentSieId,
        disciplineTypeId,
      });
      item.serviceOfferingData = data;
      this.tabsModel = this.canAddDiagnosis ? 3 : 2;
      this.$forceUpdate();
    },
    async onChangeTab(tab, item) {
      if (tab === (this.canAddDiagnosis ? 3 : 2)) {
        const { academicYearId, studentSieId, disciplineTypeId } = item;
        const { data } = await getStudentServiceOffering({
          academicYearId,
          studentSieId,
          disciplineTypeId,
        });
        item.serviceOfferingData = data;
        this.$forceUpdate();
      }
    },
    async onPrint(item) {
      const { studentSieId, disciplineTypeId, academicYearId } = item;
      await DocumentsService.downloadWeeklycompliance({
        academicYearId: academicYearId,
        studentSieId: studentSieId,
        serviceId: disciplineTypeId,
      });
    },
    async returnStatusToPrevious(admission) {
      const self = this;
      await returnAdmissionToPreviousStatus(admission.admissionId)
        .then(() => {
          self.ShowToast(
            'Proceso exitoso',
            'Proceso realizado con éxito.',
            'success'
          );
          this.SearchThrpyReferrals(this.currentFilters, false);
        })
        .catch((error) => {
          self.ShowToast(
            'Error',
            error?.response?.data?.message ?? error?.message,
            'error'
          );
        });
    },
  },
  beforeRouteEnter(_, from, next) {
    const ROUTE_NAME_FROM = 'pei';
    next((vm) => {
      if (from.name === ROUTE_NAME_FROM) {
        vm.setReferralResetSelection();
      }
    });
  },
  async mounted() {
    await this.fetchBlogCommentTypes();
    this.getCurrentAcademicYear();
    //GET FILTERS BASIC (ONLY ACADEMIC YEARS AND CURRENT ACADEMIC YEAR AND RESOURCES)
    this.getFilters({ searchMode: SearchMode.Basic });
    this.loadMessages(['190714', 'R03200160']);
    if (this.referrals.length > 0) {
      await this.SearchThrpyReferrals(this.currentFilters, false);
    }
    await this.getSysParams();
  },
};
</script>
<style scoped>
#searchLocationContainer {
  width: 98%;
}

/* Table */
#searchLocationContainer >>> td,
#searchLocationContainer >>> tr,
#searchLocationContainer >>> th {
  text-align: left;
}

#searchLocationContainer >>> .vgt-searchLocation thead th {
  border-top: none;
  font-weight: bold;
}
#searchLocationContainer >>> .vgt-searchLocation th {
  text-align: center;
  border-bottom: none !important;
}
#searchLocationContainer >>> .vgt-searchLocation td {
  padding: 1em 10px;
  vertical-align: top;
  text-align: left;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
  padding-bottom: 0;
  border-top: none !important;
}

#searchLocationContainer >>> .vgt-searchLocation th {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

#searchLocationContainer >>> div.vgt-responsive {
  overflow-x: visible;
}

.grey-border {
  border-bottom: 1px #cacdcf solid !important;
}

.custom-row .border-separator {
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: #6c757d24;
  /* border-top: 16px;     */
  /* top: 10px; */
}

.custom-row-information {
  float: left;
  width: 26%;
  margin-top: 20px;
  padding-left: 15px;
}

.custom-row-information b {
  font-size: 14px;
}

.custom-row-information .first-row {
  padding-bottom: 20px;
}

.custom-row-information-command {
  float: right;
  width: 18%;
  margin-top: 20px;
  padding-right: 5px;
}

.custom-row-services {
  float: left;
  margin-left: 10px;
  margin-top: 30px;
}

.custom-row-services a {
  margin-top: 10px;
  float: left;
  font-size: 10px;
  width: 100%;
}

.custom-row-services b {
  float: left;
  width: 100%;
}

.custom-row {
  background-color: #f7f7f7;
  padding-bottom: 20px;
  border-left-width: 5px;
  border-left-style: solid;
  border-radius: 5px;
}

.custom-row .border-separator {
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: #6c757d24;
}

.custom-row-information-collapse {
  border: #f7f7f7;
  border-width: 10px;
  border-style: solid;
}

.custom-row-information-collapse-panel {
  float: left;
  margin-left: 25px;
}

.custom-row {
  border-left-color: #a4e5b2;
}

.badge {
  white-space: normal !important;
}

.badges {
  font: Bold 16px/14px Lato;
  color: black;
  font-size: 16px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}

.row-active-service-orange {
  border-left-color: #f8ca80;
}
.badge-active-service-orange {
  background-color: #f8ca80;
}

.row-active-service-yellow {
  border-left-color: #f8ea80;
}
.badge-active-service-yellow {
  background-color: #f8ea80;
}

.row-active-service-pink {
  border-left-color: #fcc9c8;
}
.badge-active-service-pink {
  background-color: #fcc9c8;
}

.row-active-service-violet {
  border-left-color: #ddb3d7;
}
.badge-active-service-violet {
  background-color: #ddb3d7;
}

.row-active-service-green {
  border-left-color: #a4e5b2;
}
.badge-active-service-green {
  background-color: #a4e5b2;
}

.row-active-service-brown {
  border-left-color: #d5b89a;
}
.badge-active-service-brown {
  background-color: #d5b89a;
}
.row-active-service-turn {
  border-left-color: #e2e2e2;
}
.badge-active-service-turn {
  background-color: #ff7058;
  width: 75px;
  border-radius: 100px;
}

label {
  color: #727272;
}
b {
  color: #11291b;
}
.badge-expiration {
  background: #fd3838 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  text-align: left;
  font: 16px/28px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  padding: 3px 8px 3px 8px;
}

.red-icon {
  color: #ff7058;
}
.orange-icon {
  color: #ffa600;
  float: left;
}

.rp-alert {
  display: flex !important;
  font: 14px/18px Lato;
  color: #11291b;
  opacity: 1;
  padding-left: 8px;
}
.referral-additional-info {
  padding: 0px;
  margin-top: -4px;
  margin-left: 0px;
}

.wait-list-discipline p {
  text-align: left;
  font: Bold 16px/28px Lato;
  letter-spacing: 0px;
  color: #11291b;
  opacity: 1;
  text-align: center;
}
.turn-number {
  text-align: center;
  font: Bold 18px/28px Lato;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.turn-label {
  margin-bottom: 15px;
  text-align: center;
  font: Regular 14px/28px Lato;
  letter-spacing: 0px;
  color: #727272;
  opacity: 1;
}
.col-balloon {
  min-width: 265px !important;
}

::v-deep .fa-calendar-circle-user {
  background-image: url('../../../assets/img/calendar-user-circle-green.svg');
  width: 19px;
  height: 25px;
  position: absolute;
  top: 5px;
  background-repeat: no-repeat;
  background-position: center;
}

::v-deep .fa-calendar-circle-user + span {
  margin-left: 25px;
}
</style>
